








































































import Vue from 'vue'
import { DeresmaGaineForm, MaterialsGaine } from "@/models/SeismicForm"

import SimpleChooser from "@/components/DeresmaGaine/SimpleChooser.vue"
import StrictChooser from "@/components/DeresmaGaine/StrictChooser.vue"
import PointsParticuliers from "@/components/SeismicInsepctionForm/_PointsParticuliers.vue"

export default Vue.extend({
  components: {
    PointsParticuliers,
    SimpleChooser
  },
  props: {
    form: {
      type: DeresmaGaineForm,
      required: true
    },
    showsSelect: {
      type: Boolean,
      required: false
    }
  },

  data () {
    return {
      materialsGaine: MaterialsGaine
    }
  }

})
